import React from 'react'
import {
  StyledImage,
  Title,
  Text,
  AlertBox,
  Content
} from './SchoolNotFound.styles'
import Cdn from 'utils/assets/Cdn'
import { Button } from 'components/lib/buttons'
import { tokens, FontIcon } from '@arvoreeducacao/bonsai-ds'
import { withRouter } from 'react-router-dom'
import { COMBO_URL } from 'config/vars'
import { hotjarEvent } from 'utils/ui-trackers/hotjar'
import { useTranslation } from 'i18n'

const SchoolNotFound = () => {
  const openResetPasswordPage = () => {
    window.open(`${COMBO_URL}/login/recuperar-acesso`, '_self')
    hotjarEvent('recovery-access')
  }

  const redirectToLoginPage = () => {
    window.open(`${COMBO_URL}/login`, '_self')
    hotjarEvent('school_not_found')
  }

  const { t } = useTranslation()

  return (
    <>
      <Content>
        <StyledImage
          src={Cdn.getImageUrl('missing-information.png')}
          alt={t('Não conseguimos encontrar a escola')}
        />
        <Title>{t('Não conseguimos encontrar a escola')}</Title>
        <Text>
          {t(
            'Verifique o código da escola e tente novamente. Se ainda assim não conseguir, entre em contato com nosso suporte.'
          )}
        </Text>
        <AlertBox>
          <FontIcon
            color={tokens.colors.black5}
            size={16}
            iconName="stopsign-alert"
          />
          <p>
            {t(
              'Caso já tenha realizado sua assinatura, utilize seu login de acesso pessoal. Caso não se lembre como acessar'
            )}{' '}
            <label onClick={() => openResetPasswordPage()}>
              {t('recupere seu acesso.')}
            </label>
          </p>
        </AlertBox>
        <Button
          outline
          size="medium"
          color={tokens.colors.black4}
          onClick={() => redirectToLoginPage()}
        >
          {t('Voltar')}
        </Button>
      </Content>
    </>
  )
}

export default withRouter(SchoolNotFound)
